export default "__VITE_ASSET__BEGmo7JA__"